var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchantIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10201",
    "data-name": "Group 10201",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70.283,
    height: 70.321,
    viewBox: "0 0 70.283 70.321",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3567",
    "data-name": "Rectangle 3567",
    width: 70.283,
    height: 70.321,
    fill: "#e0186a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10200",
    "data-name": "Group 10200",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32408",
    "data-name": "Path 32408",
    d: "M21.1,6.591A19.329,19.329,0,0,0,8.79,24.612v5.274H6.116A6.13,6.13,0,0,0,0,36v8.865a6.13,6.13,0,0,0,6.116,6.116h.917v5.384A10.445,10.445,0,0,0,17.47,66.8h9.2a5.239,5.239,0,0,0,4.972,3.516h7.032a5.274,5.274,0,1,0,0-10.548H31.644a5.239,5.239,0,0,0-4.972,3.516h-9.2a6.993,6.993,0,0,1-4.9-2.023,6.9,6.9,0,0,1-2.023-4.9V50.983a1.759,1.759,0,0,0,1.758-1.758V24.612a15.839,15.839,0,0,1,9.707-14.6,4.869,4.869,0,0,0,.612.762,5.282,5.282,0,0,0,3.708,1.547H43.951a5.261,5.261,0,0,0,3.708-1.547,4.752,4.752,0,0,0,.614-.762,15.86,15.86,0,0,1,9.7,14.6V49.225a1.765,1.765,0,0,0,1.758,1.758h4.433a6.126,6.126,0,0,0,6.116-6.116V36a6.126,6.126,0,0,0-6.116-6.116H61.493V24.612A19.344,19.344,0,0,0,49.187,6.591V5.255A5.282,5.282,0,0,0,43.932,0H26.316a5.286,5.286,0,0,0-5.258,5.255V6.591Zm10.548,56.7a1.758,1.758,0,1,0,0,3.516h7.032a1.758,1.758,0,0,0,0-3.516Zm-.952-15.822,2.993,4.486a1.781,1.781,0,0,0,1.456.788,1.755,1.755,0,0,0,1.456-.788l3-4.486H47.52a5.178,5.178,0,0,0,3.673-1.528,5.234,5.234,0,0,0,1.528-3.673V24.521a5.2,5.2,0,0,0-5.2-5.2H22.744a5.209,5.209,0,0,0-5.2,5.2V42.265a5.222,5.222,0,0,0,5.2,5.2ZM33.1,44.738a1.781,1.781,0,0,0-1.456-.788H22.782A1.689,1.689,0,0,1,21.1,42.265V24.521a1.692,1.692,0,0,1,1.685-1.685H47.558a1.692,1.692,0,0,1,1.685,1.685V42.265a1.689,1.689,0,0,1-1.685,1.685H38.7a1.755,1.755,0,0,0-1.456.788l-2.06,3.075-2.06-3.075ZM8.79,47.467H6.116a2.614,2.614,0,0,1-1.831-.759,2.549,2.549,0,0,1-.75-1.824V36.021a2.646,2.646,0,0,1,.75-1.831,2.6,2.6,0,0,1,1.831-.75H8.79V47.467ZM66.8,36v8.865a2.614,2.614,0,0,1-.759,1.831,2.565,2.565,0,0,1-1.824.75H61.549V33.384h2.672a2.581,2.581,0,0,1,1.824.759,2.536,2.536,0,0,1,.759,1.824ZM45.709,5.255v1.8A1.753,1.753,0,0,1,43.969,8.79H26.352a1.689,1.689,0,0,1-1.226-.513,1.711,1.711,0,0,1-.513-1.226v-1.8a1.753,1.753,0,0,1,1.739-1.739H43.969a1.753,1.753,0,0,1,1.739,1.739",
    fill: "#e0186a",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantIcon6);
export default __webpack_public_path__ + "static/media/merchant-icon6.3f1f50aa5e158b12d4012b390f0cfa95.svg";
export { ForwardRef as ReactComponent };